// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-speak-assist-container {
  padding: 20px;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}

.voice-assistant-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.main-content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  min-height: 400px;
  background: #f0f2f5;
}

.voice-input-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  animation: fadeIn 0.3s ease-in;
}
.voice-input-indicator .listening-animation {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
}
.voice-input-indicator .wave {
  width: 8px;
  height: 40px;
  background: #133aa5;
  border-radius: 4px;
  animation: waveAnimation 1.2s ease-in-out infinite;
}
.voice-input-indicator .wave:nth-child(1) {
  animation-delay: 0s;
}
.voice-input-indicator .wave:nth-child(2) {
  animation-delay: 0.15s;
}
.voice-input-indicator .wave:nth-child(3) {
  animation-delay: 0.3s;
}
.voice-input-indicator .wave:nth-child(4) {
  animation-delay: 0.45s;
}
.voice-input-indicator .wave:nth-child(5) {
  animation-delay: 0.6s;
}
.voice-input-indicator .listening-text {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #133aa5;
}
.voice-input-indicator .listening-hint {
  margin: 0;
  font-size: 16px;
  color: #666;
  font-weight: 400;
}

.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: fadeIn 0.3s ease-in;
}
.processing-indicator .ai-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #1571b9;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.processing-indicator .ai-avatar i {
  font-size: 40px;
  color: white;
}
.processing-indicator .typing-indicator {
  display: flex;
  gap: 6px;
}
.processing-indicator .typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #133aa5;
  animation: typing 1.4s infinite;
}
.processing-indicator .typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}
.processing-indicator .typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}
.processing-indicator .typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}
.processing-indicator .processing-text {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #133aa5;
  text-align: center;
  max-width: 800px;
  word-wrap: break-word;
  line-height: 1.6;
  padding: 0 20px;
}
.processing-indicator .processing-text .word {
  display: inline-block;
  animation: wordFadeIn 0.3s ease-out;
}
.processing-indicator .processing-text .word .space {
  display: inline;
}

.subtitle-container {
  width: 100%;
  max-width: 900px;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  justify-content: center;
  scroll-behavior: smooth;
}
.subtitle-container .subtitle-content {
  background: #ffffff;
  padding: 32px 40px;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.subtitle-container .subtitle-content.speaking {
  background: #e3f2fd;
  border-left: 3px solid #133aa5;
  box-shadow: 0 2px 8px rgba(19, 58, 165, 0.2);
}
.subtitle-container .subtitle-content .subtitle-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #133aa5;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: iconPulse 1.5s infinite;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.subtitle-container .subtitle-content .subtitle-icon i {
  font-size: 20px;
  color: white;
}
.subtitle-container .subtitle-content .subtitle-text {
  margin: 0;
  font-size: 24px;
  line-height: 1.6;
  color: #333;
  font-weight: 400;
  text-align: left;
  word-wrap: break-word;
  flex: 1;
  width: 100%;
}
.subtitle-container .subtitle-content .subtitle-text .word {
  display: inline-block;
}
.subtitle-container .subtitle-content .subtitle-text .word .space {
  display: inline;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #666;
  animation: fadeIn 0.5s ease-in;
}
.empty-state .empty-state-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #1571b9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(19, 58, 165, 0.3);
}
.empty-state .empty-state-icon i {
  font-size: 36px;
  color: white;
}
.empty-state h3 {
  font-size: 24px;
  margin: 0 0 8px 0;
  font-weight: 600;
  color: #333;
}
.empty-state p {
  font-size: 16px;
  margin: 0;
  color: #666;
}

.voice-control-panel {
  background: #ffffff;
  padding: 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

.mic-button {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #1571b9;
  color: white;
  font-size: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(19, 58, 165, 0.4);
  transition: all 0.3s ease;
}
.mic-button:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(19, 58, 165, 0.6);
  background: #1a4bb8;
}
.mic-button:active:not(:disabled) {
  transform: scale(0.95);
}
.mic-button.recording {
  background: #d32f2f;
  animation: recordingPulse 1.5s infinite;
  box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);
}
.mic-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.clear-button {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #666;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(102, 102, 102, 0.4);
  transition: all 0.3s ease;
}
.clear-button:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 102, 102, 0.6);
  background: #777;
}
.clear-button:active:not(:disabled) {
  transform: scale(0.95);
}
.clear-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  transition: all 0.3s ease;
}
.status-dot.active {
  background: #d32f2f;
  animation: statusPulse 1.5s infinite;
}
.status-dot.processing {
  background: #133aa5;
  animation: statusPulse 1.5s infinite;
}
.status-dot.speaking {
  background: #133aa5;
  animation: statusPulse 1.5s infinite;
}

.status-text {
  font-weight: 500;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes waveAnimation {
  0%, 100% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
}
@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-12px);
    opacity: 1;
  }
}
@keyframes recordingPulse {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);
  }
  50% {
    box-shadow: 0 4px 24px rgba(211, 47, 47, 0.9), 0 0 0 8px rgba(211, 47, 47, 0.2);
  }
}
@keyframes statusPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes subtitlePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
}
@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
@keyframes wordFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.page-title .icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.page-title .icon:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/live-speak-assist/live-speak-assist.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AACF;AACE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAEE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,sBAAA;AADN;AAII;EACE,qBAAA;AAFN;AAKI;EACE,sBAAA;AAHN;AAMI;EACE,qBAAA;AAJN;AAQE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AANJ;AASE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;AARJ;AAUI;EACE,eAAA;EACA,YAAA;AARN;AAYE;EACE,aAAA;EACA,QAAA;AAVJ;AAYI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAaM;EACE,qBAAA;AAXR;AAcM;EACE,qBAAA;AAZR;AAiBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,mCAAA;AAfN;AAiBM;EACE,eAAA;AAfR;;AAqBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAlBF;AAoBE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iDAAA;EACA,6BAAA;EACA,4BAAA;EAAA,uBAAA;AAlBJ;AAoBI;EACE,mBAAA;EACA,8BAAA;EACA,4CAAA;AAlBN;AAqBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,kDAAA;AAnBN;AAqBM;EACE,eAAA;EACA,YAAA;AAnBR;AAuBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;AArBN;AAuBM;EACE,qBAAA;AArBR;AAuBQ;EACE,eAAA;AArBV;;AA4BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;AAzBF;AA2BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;AAzBJ;AA2BI;EACE,eAAA;EACA,YAAA;AAzBN;AA6BE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AA3BJ;AA8BE;EACE,eAAA;EACA,SAAA;EACA,WAAA;AA5BJ;;AAgCA;EACE,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,yBAAA;AA7BF;AA+BE;EACE,sBAAA;EACA,6CAAA;EACA,mBAAA;AA7BJ;AAgCE;EACE,sBAAA;AA9BJ;AAiCE;EACE,mBAAA;EACA,uCAAA;EACA,6CAAA;AA/BJ;AAkCE;EACE,YAAA;EACA,mBAAA;AAhCJ;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,yBAAA;AAjCF;AAmCE;EACE,sBAAA;EACA,+CAAA;EACA,gBAAA;AAjCJ;AAoCE;EACE,sBAAA;AAlCJ;AAqCE;EACE,YAAA;EACA,mBAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AApCF;AAsCE;EACE,mBAAA;EACA,oCAAA;AApCJ;AAuCE;EACE,mBAAA;EACA,oCAAA;AArCJ;AAwCE;EACE,mBAAA;EACA,oCAAA;AAtCJ;;AA0CA;EACE,gBAAA;AAvCF;;AA0CA;EACE;IACE,UAAA;EAvCF;EA0CA;IACE,UAAA;EAxCF;AACF;AA2CA;EACE;IACE,UAAA;IACA,2BAAA;EAzCF;EA4CA;IACE,UAAA;IACA,wBAAA;EA1CF;AACF;AA6CA;EAEE;IAEE,sBAAA;EA7CF;EAgDA;IACE,oBAAA;EA9CF;AACF;AAiDA;EAEE;IAGE,wBAAA;IACA,YAAA;EAlDF;EAqDA;IACE,4BAAA;IACA,UAAA;EAnDF;AACF;AAsDA;EAEE;IAEE,6CAAA;EAtDF;EAyDA;IACE,+EAAA;EAvDF;AACF;AA0DA;EAEE;IAEE,UAAA;EA1DF;EA6DA;IACE,YAAA;EA3DF;AACF;AA8DA;EAEE;IAEE,mBAAA;EA9DF;EAiEA;IACE,sBAAA;EA/DF;AACF;AAkEA;EAEE;IAEE,mBAAA;EAlEF;EAqEA;IACE,qBAAA;EAnEF;AACF;AAsEA;EACE;IACE,UAAA;IACA,2BAAA;EApEF;EAuEA;IACE,UAAA;IACA,wBAAA;EArEF;AACF;AAyEE;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAvEJ;AAyEI;EACE,YAAA;AAvEN","sourcesContent":[".live-speak-assist-container {\n  padding: 20px;\n  height: calc(100vh - 120px);\n  display: flex;\n  flex-direction: column;\n}\n\n.voice-assistant-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.main-content-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  position: relative;\n  min-height: 400px;\n  background: #f0f2f5;\n}\n\n.voice-input-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  animation: fadeIn 0.3s ease-in;\n\n  .listening-animation {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .wave {\n    width: 8px;\n    height: 40px;\n    background: #133aa5;\n    border-radius: 4px;\n    animation: waveAnimation 1.2s ease-in-out infinite;\n\n    &:nth-child(1) {\n      animation-delay: 0s;\n    }\n\n    &:nth-child(2) {\n      animation-delay: 0.15s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 0.3s;\n    }\n\n    &:nth-child(4) {\n      animation-delay: 0.45s;\n    }\n\n    &:nth-child(5) {\n      animation-delay: 0.6s;\n    }\n  }\n\n  .listening-text {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #133aa5;\n  }\n\n  .listening-hint {\n    margin: 0;\n    font-size: 16px;\n    color: #666;\n    font-weight: 400;\n  }\n}\n\n.processing-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  animation: fadeIn 0.3s ease-in;\n\n  .ai-avatar {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: #1571b9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n\n    i {\n      font-size: 40px;\n      color: white;\n    }\n  }\n\n  .typing-indicator {\n    display: flex;\n    gap: 6px;\n\n    span {\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      background: #133aa5;\n      animation: typing 1.4s infinite;\n\n      &:nth-child(1) {\n        animation-delay: 0s;\n      }\n\n      &:nth-child(2) {\n        animation-delay: 0.2s;\n      }\n\n      &:nth-child(3) {\n        animation-delay: 0.4s;\n      }\n    }\n  }\n\n  .processing-text {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #133aa5;\n    text-align: center;\n    max-width: 800px;\n    word-wrap: break-word;\n    line-height: 1.6;\n    padding: 0 20px;\n\n    .word {\n      display: inline-block;\n      animation: wordFadeIn 0.3s ease-out;\n\n      .space {\n        display: inline;\n      }\n    }\n  }\n}\n\n.subtitle-container {\n  width: 100%;\n  max-width: 900px;\n  max-height: 50vh;\n  overflow-y: auto;\n  overflow-x: auto;\n  display: flex;\n  justify-content: center;\n  scroll-behavior: smooth;\n\n  .subtitle-content {\n    background: #ffffff;\n    padding: 32px 40px;\n    border-radius: 18px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    border: 2px solid transparent;\n    min-height: fit-content;\n\n    &.speaking {\n      background: #e3f2fd;\n      border-left: 3px solid #133aa5;\n      box-shadow: 0 2px 8px rgba(19, 58, 165, 0.2);\n    }\n\n    .subtitle-icon {\n      flex-shrink: 0;\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      background: #133aa5;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      animation: iconPulse 1.5s infinite;\n      transition: transform 0.3s ease, opacity 0.3s ease;\n\n      i {\n        font-size: 20px;\n        color: white;\n      }\n    }\n\n    .subtitle-text {\n      margin: 0;\n      font-size: 24px;\n      line-height: 1.6;\n      color: #333;\n      font-weight: 400;\n      text-align: left;\n      word-wrap: break-word;\n      flex: 1;\n      width: 100%;\n\n      .word {\n        display: inline-block;\n\n        .space {\n          display: inline;\n        }\n      }\n    }\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #666;\n  animation: fadeIn 0.5s ease-in;\n\n  .empty-state-icon {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: #1571b9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n    box-shadow: 0 4px 12px rgba(19, 58, 165, 0.3);\n\n    i {\n      font-size: 36px;\n      color: white;\n    }\n  }\n\n  h3 {\n    font-size: 24px;\n    margin: 0 0 8px 0;\n    font-weight: 600;\n    color: #333;\n  }\n\n  p {\n    font-size: 16px;\n    margin: 0;\n    color: #666;\n  }\n}\n\n.voice-control-panel {\n  background: #ffffff;\n  padding: 24px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.button-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.mic-button {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: none;\n  background: #1571b9;\n  color: white;\n  font-size: 32px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(19, 58, 165, 0.4);\n  transition: all 0.3s ease;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(19, 58, 165, 0.6);\n    background: #1a4bb8;\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &.recording {\n    background: #d32f2f;\n    animation: recordingPulse 1.5s infinite;\n    box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.clear-button {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: none;\n  background: #666;\n  color: white;\n  font-size: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(102, 102, 102, 0.4);\n  transition: all 0.3s ease;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(102, 102, 102, 0.6);\n    background: #777;\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.95);\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #666;\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ccc;\n  transition: all 0.3s ease;\n\n  &.active {\n    background: #d32f2f;\n    animation: statusPulse 1.5s infinite;\n  }\n\n  &.processing {\n    background: #133aa5;\n    animation: statusPulse 1.5s infinite;\n  }\n\n  &.speaking {\n    background: #133aa5;\n    animation: statusPulse 1.5s infinite;\n  }\n}\n\n.status-text {\n  font-weight: 500;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes waveAnimation {\n\n  0%,\n  100% {\n    transform: scaleY(0.3);\n  }\n\n  50% {\n    transform: scaleY(1);\n  }\n}\n\n@keyframes typing {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n\n  30% {\n    transform: translateY(-12px);\n    opacity: 1;\n  }\n}\n\n@keyframes recordingPulse {\n\n  0%,\n  100% {\n    box-shadow: 0 4px 16px rgba(211, 47, 47, 0.6);\n  }\n\n  50% {\n    box-shadow: 0 4px 24px rgba(211, 47, 47, 0.9), 0 0 0 8px rgba(211, 47, 47, 0.2);\n  }\n}\n\n@keyframes statusPulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes subtitlePulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.01);\n  }\n}\n\n@keyframes iconPulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n@keyframes wordFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.page-title {\n  .icon {\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
